export default "__VITE_ASSET__CwVz43DB__"